import { CalculationItem } from '@features/glossary';
import { Calculations as CalculationsType } from '@features/glossary';
import { Grid, Stack, Typography } from '@mui/material';

type CalculationsProps = {
  calculations: CalculationsType;
};

const Calculations = (props: CalculationsProps) => (
  <Stack id="help_calculations" className="tab-pane" padding={2} spacing={2}>
    {Object.values(props.calculations).map(calculationSection => (
      <Stack key={calculationSection.label}>
        <Typography variant="h4">{calculationSection.label}</Typography>
        <Grid container paddingTop={2} spacing={2}>
          {Object.values(calculationSection.items).map(
            // TODO: Why does `calculationItem` default to `any`?
            (calculationItem: CalculationItem) => (
              <Grid
                key={calculationItem.label}
                size={{
                  md: 6,
                }}
              >
                <Stack spacing={1}>
                  <Typography variant="h5" fontWeight={600}>
                    {calculationItem.label}
                  </Typography>
                  {'calculation' in calculationItem ? (
                    <Typography fontStyle="italic">
                      {calculationItem.calculation}
                    </Typography>
                  ) : (
                    Object.values(calculationItem.calculationByType).map(
                      calculation => (
                        <Typography fontStyle="italic" key={calculation}>
                          {calculation}
                        </Typography>
                      )
                    )
                  )}
                  {calculationItem.additionalCalculations
                    ? calculationItem.additionalCalculations.map(
                        calculation => (
                          <Typography fontStyle="italic" key={calculation}>
                            {calculation}
                          </Typography>
                        )
                      )
                    : null}
                  {'note' in calculationItem && (
                    <Typography fontStyle="italic">
                      {calculationItem.note}
                    </Typography>
                  )}
                </Stack>
              </Grid>
            )
          )}
        </Grid>
      </Stack>
    ))}
  </Stack>
);

export default Calculations;
